<script>

</script>

<section class="py-5">
    <div class="container">
        <h1 class="h2 mb-5">GDPR Consent – Personal Data Processing</h1>

        <div class="mb-5">
            <h2 class="h3">Personal Data Processing Consent Form (GDPR)</h2>
            <p>
                In accordance with Regulation (EU) 2016/679 of the European Parliament and of
                the Council (General Data Protection Regulation – GDPR), I hereby declare that I
                have been informed in a clear and comprehensive manner about the collection,
                processing, storage, and use of my personal data by Regent Mile P.C.
            </p>
        </div>
        <div class="mb-5">
            <h3 class="h4">1. Purpose of Data Processing</h3>
            <p>
                I consent to the processing of my personal data for the purposes of:
            </p>
            <ul>
                <li>Communication and customer support</li>
                <li>Provision of services and contractual obligations</li>
                <li>Legal, regulatory, and tax compliance</li>
                <li>Internal administrative and operational purposes</li>
            </ul>
        </div>
        <div class="mb-5">
            <h3 class="h4">2. Types of Personal Data</h3>
            <p>
                The personal data that may be processed include, but are not limited to:
            </p>
            <ul>
                <li>Full name</li>
                <li>Contact details (email address, phone number, postal address)</li>
                <li>Identification and billing information</li>
                <li>Any additional information voluntarily provided</li>
            </ul>
        </div>
        <div class="mb-5">
            <h3 class="h4">3. Data Storage &amp; Security</h3>
            <p>
                My personal data will be stored securely and processed only for as long as
                necessary to fulfill the purposes stated above, in compliance with applicable legal
                obligations and internal data retention policies.
            </p>
        </div>
        <div class="mb-5">
            <h3 class="h4">4. Data Sharing</h3>
            <p>
                My data will not be disclosed to third parties, except where required by law or
                where necessary for the fulfillment of contractual or legal obligations.
            </p>
        </div>
        <div class="mb-5">
            <h3 class="h4">5. Data Subject Rights</h3>
            <p>
                I acknowledge that I have the right to:
            </p>
            <ul>
                <li>Access my personal data</li>
                <li>Request correction or deletion of my data</li>
                <li>Restrict or object to processing</li>
                <li>Withdraw my consent at any time</li>
                <li>Lodge a complaint with a supervisory authority</li>
            </ul>
            <p>
                Requests regarding personal data may be submitted to info@regentmile.gr
            </p>
        </div>

        <div class="mb-5">
            <h3 class="h4">6. Cancellation Policy</h3>
            <ul>
                <li>Free cancellation up to 24 hours prior to the scheduled pickup time</li>
                <li>Cancellations made less than 24 hours before pickup are subject to a 75% charge</li>
                <li>Cancellations made within 2 hours before pickup are subject to a 100% charge</li>
            </ul>
        </div>

        <div>
            <h3 class="h4">7. Consent Declaration</h3>
            <p>
                By signing this form / selecting the relevant checkbox, I confirm that:
            </p>
            <ul>
                <li>I have read and understood this consent form</li>
                <li>I voluntarily give my explicit consent to the processing of my personal data</li>
                as described above
            </ul>
        </div>
    </div>
</section>